import url from '../url'
import headers from '../headers'

export default {
	getListAll (context, user_uid, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/completed/?size=${size}`,
			headers.bearer()
		)
	},
	getAll (context, user_uid, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/?size=${size}`,
			headers.bearer()
		)
	},
	getAllPermitted (context, user_uid, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/permissions/watches/?size=${size}`,
			headers.bearer()
		)
	},
	get (context, user_uid, watch_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/`,
			headers.bearer()
		)
	},
	edit (context, user_uid, watch_id, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/watches/${watch_id}/`,
			model,
			headers.bearer()
		)
	},
	admin: {
		getAll (context, offset = 0, size = 999) {
			return context.$http.get(
				`${url}/watches/?offset=${offset}&size=${size}`,
				headers.bearer()
			)
		},
		get (context, watch_id) {
			return context.$http.get(
				`${url}/watches/${watch_id}`,
				headers.bearer()
			)
		},
		add (context, model) {
			return context.$http.post(
				`${url}/watches`,
				model,
				headers.bearer()
			)
		},
		edit (context, model) {
			return context.$http.put(
				`${url}/watches/${model.id}`,
				model,
				headers.bearer()
			)
		},
		delete (context, id) {
			return context.$http.delete(
				`${url}/watches/${id}`,
				headers.bearer()
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/watches.js